// @flow

import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

const createStyles = makeStyles(theme => ({
  text: {
    textAlign: 'center',
    letterSpacing: 0.44,
    [theme.breakpoints.down('xs')]: {
      fontSize: 15,
      lineHeight: 1.72,
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: 20,
      lineHeight: 1.69,
    },
  },
}));

type Props = {
  status: string,
  className?: string,
};
const TrackingStatus = ({ status, className }: Props) => {
  const styles = createStyles();

  return (
    <Typography className={clsx(styles.text, className)}>{status}</Typography>
  );
};

export default TrackingStatus;
